import {
    CBAR_LOG_CREATE,
    CBAR_LOG_CREATE_FAIL,
    CBAR_LOG_CREATE_SUCCESS,
    DELETE_CBAR_LOG,
    DELETE_CBAR_LOG_FAIL,
    DELETE_CBAR_LOG_SUCCESS,
    GET_CBAR_LOG_DETAILS,
    GET_CBAR_LOG_DETAILS_FAIL,
    GET_CBAR_LOG_DETAILS_SUCCESS,
    RESET,
    RESET_CBAR_LOG_CREATE,
    RESET_CBAR_LOG_DELETE,
    RESET_CBAR_LOG_DETAILS,
    UPDATE_CBAR_LOG,
    UPDATE_CBAR_LOG_FAIL,
    UPDATE_CBAR_LOG_SUCCESS,
} from "./actionsTypes";

const initialState = {
    CBARLogList: [],
    CBARLogDetails: [],
    createResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    deleteResult: {},
    error: {
        message: "",
    },
};

const CBARLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case CBAR_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case CBAR_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case CBAR_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        case GET_CBAR_LOG_DETAILS:
            state = { ...state, detailsLoading: true, CBARLogDetails: {} };
            break;
        case GET_CBAR_LOG_DETAILS_SUCCESS:
            state = { ...state, CBARLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_CBAR_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        case UPDATE_CBAR_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_CBAR_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_CBAR_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case DELETE_CBAR_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_CBAR_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_CBAR_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;
        case RESET_CBAR_LOG_DETAILS:
            state = { ...state, CBARLogDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, CBARLogList: [], createResult: {} };
            break;
        case RESET_CBAR_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        case RESET_CBAR_LOG_DELETE:
            state = { ...state, deleteResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default CBARLogReducer;